<template>
	<div>
		<div>
			<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">投标汇总表</div>
			<el-row style="margin-top: 9px;">
				<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

					<el-row style="padding-left: 46px; padding-top: 40px;">

						<el-col :span="5">
							<span>类别</span>
							<el-select v-model="spare" placeholder="请选择" style="">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="2">
							<el-button
								style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
								@click="Find">
								查询</el-button>
						</el-col>
						<el-col :span="3">
							<download-excel class="export-excel-wrapper" :fields="download_excel" name="工资汇总表"
								:fetch="ExportForm" style="">
								<el-button
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</el-col>
					</el-row>

					<el-row style="margin: 0px 2%; margin-top: 20px;">
						<el-row style="margin-top: 10px;">
							<el-table :data="tableData" :header-cell-style="{background:'#d3eae2',color:'#000000'}"
								:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
								style="width: 100%" @cell-mouse-leave="cellMouseLeave" :summary-method="getSummaries"
								@cell-mouse-enter="cellMouseEnter" height="600" :cell-class-name="tableRowClassName">
								<el-table-column prop="organizeName" align="center" label="分类">
								</el-table-column>
								<el-table-column prop="andInnovationSummary" align="center" label=""></el-table-column>
								</el-table-column>
								<el-table-column align="center" label="架构">
									<el-table-column v-for="(item, index) in tableTable" align="center"
										:label="item.organizeName" :key="index">
										<el-table-column v-for="(a,b) in item.gaugeList" :label="a.gaugeName" :key="b"
											align="center">
											<template slot-scope="scope">
												{{money(scope.row.moneyMap, item.organizeName, a.gaugeName)}}
											</template>
										</el-table-column>
									</el-table-column>
								</el-table-column>
								<el-table-column prop="uncollectedPaymentMoney" align="center" label="合计"></el-table-column>
								<el-table-column prop="moneyProportion" align="center" label="占比"></el-table-column>
							</el-table>
						</el-row>
					</el-row>

				</div>
			</el-row>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		components: {},
		data() {
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				tableTable: [],
				orderIndexArr: [],
				hoverOrderArr: [],
				ids: [],
				options: [{
					value: '0',
					label: '全部'
				}, {
					value: '1',
					label: '保证金'
				}, {
					value: '2',
					label: '履约金'
				}],
				spare: '0',
				download_excel: {},

				//复选框ids
				ids: [],
			};
		},
		methods: {
			headerStyle({ row, column, rowIndex, columnIndex }) {
			      // 让第一行的第二个元素占2行
			      if (rowIndex == 0) {
			        row[1].rowSpan = 2;
			      }
			      if (rowIndex == 1) {
			        row[0].colSpan = 0;
			        row[1].colSpan = 0;
			        if (columnIndex == 0 || columnIndex == 1) {
			          return {
			            display: "none",
			          };
			        }
			      }
			      // return {
			      //   backgroundColor: "green",
			      // };
			    },
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			//查询
			Find() {
				const url = this.$globals.http + "tenderBond/bidSummary";
				axios.post(url, {
					spare: this.spare
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.tableTable = data.table;
						this.getOrderNumber()
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			getOrderNumber() {
				const orderObj = {};
				this.tableData.forEach((item, index) => {
					item.rowIndex = index;
					if (orderObj[item.organizeName]) {
						orderObj[item.organizeName].push(index);
					} else {
						orderObj[item.organizeName] = [];
						orderObj[item.organizeName].push(index);
					}
				});
				// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
				Object.keys(orderObj).forEach((key) => {
					if (orderObj[key].length > 1) {
						this.orderIndexArr.push(orderObj[key]);
					}
				});
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {

					for (let i = 0; i < this.orderIndexArr.length; i += 1) {
						let element = this.orderIndexArr[i];
						for (let j = 0; j < element.length; j += 1) {
							let item = element[j];
							if (rowIndex === item) {
								if (j === 0) {
									return {
										rowspan: element.length,
										colspan: 1,
									};
								}
								if (j !== 0) {
									return {
										rowspan: 0,
										colspan: 0,
									};
								}
							}
						}
					}
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				let arr = this.hoverOrderArr;
				for (let i = 0; i < arr.length; i += 1) {
					if (rowIndex === arr[i]) {
						return 'hovered-row';
					}
				}
			},
			cellMouseEnter(row, column, cell, event) {
				this.rowIndex = row.rowIndex;
				this.hoverOrderArr = [];
				this.orderIndexArr.forEach((element) => {
					if (element.indexOf(this.rowIndex) >= 0) {
						this.hoverOrderArr = element;
					}
				});
			},
			cellMouseLeave(row, column, cell, event) {
				this.rowIndex = '-1';
				this.hoverOrderArr = [];
			},
			money(e1, e2, e3) {
				if (e1 == undefined || e1 == null || e1 == '') {
					return '';
				}
				if (e1[e2] == undefined || e1[e2] == null || e1[e2] == '') {
					return '';
				}
				if (e1[e2][e3] == undefined || e1[e2][e3] == null || e1[e2][e3] == '') {
					return '';
				}
				return e1[e2][e3];
			},
			//导表
			async ExportForm() {

			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.Find();
			},

		},
		async created() {
			this.Find();

		}
	}
</script>

<style scoped="scoped">
	.el-table td {
		padding: 0px 0 !important;
	
		.cell {
			text-align:center;
		}
	
		.cell span {
			border-right: 1px solid #ebeef5;
			padding: 10px 50px;
			width: 100px;
			margin:0 auto;
			display: inline-block;
		}
	
		.cell span:last-child {
			border: none;
		}
	}
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// Gather.vue?6090205c